import * as React from 'react';
import { EventAttributes } from '@atlassiansox/analytics-web-client';
import Button, { ButtonProps } from '@atlaskit/button';
import { AnalyticsTag, analytics, createOpenSidebarFromButtonEvent } from '@atlassian/temp-analytics';
import { ufoCommonButtonClickEvents } from '@atlassian/temp-observability';
import { useApplicationContext } from '../../common-context';
import { useSidebar } from '../../hooks';
import { SidebarOptions } from '../../state';

interface Props extends ButtonProps {
  sidebar: string;
  sidebarOptions?: SidebarOptions;
  payload?: unknown;
  analyticsAttributes?: EventAttributes;
  analyticsTags?: AnalyticsTag[];
}

export const OpenSidebarLink = ({
  sidebar,
  sidebarOptions,
  payload,
  analyticsAttributes,
  analyticsTags,
  children,
  ...buttonProps
}: Props) => {
  const { openSidebar } = useSidebar();
  // generalized way to capture all the sideBars opening on clicking some link
  const context = useApplicationContext();
  const product = context.product?.toLowerCase();
  const pageName = window.location.pathname.split('/')[1];
  const label = buttonProps.label || 'OpenSideBarLink';

  return (
    <Button
      {...buttonProps}
      onClick={() => {
        analytics.sendUIEvent(createOpenSidebarFromButtonEvent(sidebar, label, analyticsTags, analyticsAttributes));
        ufoCommonButtonClickEvents(product, pageName, label);
        openSidebar({ sidebarType: sidebar, payload, sidebarOptions });
      }}
      appearance="link"
      spacing="none"
      cellPadding="none"
    >
      {children}
    </Button>
  );
};
